import React from 'react';

export const Title = ({children}) => (
  <div className="py-12 bg-gradient-to-br from-orange-medium to-orange-dark">
    <div className="container mx-auto px-12">
      <h1 className="text-2xl text-white">{children}</h1>
    </div>
  </div>
);

export default Title;
